// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Jik8","question":"styles_question__3xbDN","description":"styles_description__2npKe"};